import axios from 'axios';

// Use relative URL in production (works with Caddy), absolute URL in development
const API_BASE_URL =
  process.env.REACT_APP_API_URL || (process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:5000/api');

class UserService {
  /**
   * Get all users
   * @returns {Promise<Array>}
   */
  async getUsers() {
    try {
      const response = await axios.get(`${API_BASE_URL}/auth/users`);
      return response.data.users;
    } catch (error) {
      console.error('Get users error:', error);
      throw new Error(error.response?.data?.error || 'Failed to fetch users');
    }
  }

  /**
   * Create a new user
   * @param {string} username - Username
   * @param {string} password - User password
   * @param {string} role - User role
   * @param {string} displayName - Optional display name
   * @returns {Promise<object>}
   */
  async createUser(username, password, role, displayName) {
    try {
      const response = await axios.post(`${API_BASE_URL}/auth/register`, {
        username,
        password,
        role,
        displayName,
      });
      return response.data.user;
    } catch (error) {
      console.error('Create user error:', error);
      throw new Error(
        error.response?.data?.error || 'Failed to create user'
      );
    }
  }

  /**
   * Update a user
   * @param {string} userId - User ID
   * @param {object} userData - User data to update (username, password, role, displayName)
   * @returns {Promise<object>}
   */
  async updateUser(userId, userData) {
    try {
      const response = await axios.put(
        `${API_BASE_URL}/auth/users/${userId}`,
        userData
      );
      return response.data.user;
    } catch (error) {
      console.error('Update user error:', error);
      throw new Error(
        error.response?.data?.error || 'Failed to update user'
      );
    }
  }

  /**
   * Delete a user
   * @param {string} userId - User ID
   * @returns {Promise<void>}
   */
  async deleteUser(userId) {
    try {
      await axios.delete(`${API_BASE_URL}/auth/users/${userId}`);
    } catch (error) {
      console.error('Delete user error:', error);
      throw new Error(
        error.response?.data?.error || 'Failed to delete user'
      );
    }
  }

  /**
   * Toggle user activation status
   * @param {string} userId - User ID
   * @param {boolean} isActive - Whether to activate or deactivate
   * @returns {Promise<object>}
   */
  async toggleActivation(userId, isActive) {
    try {
      const response = await axios.patch(
        `${API_BASE_URL}/auth/users/${userId}/activate`,
        { isActive }
      );
      return response.data.user;
    } catch (error) {
      console.error('Toggle activation error:', error);
      throw new Error(
        error.response?.data?.error || 'Failed to toggle user activation'
      );
    }
  }
}

export default new UserService();

